import PreparatoryQuickEntryPage from './_PreparatoryQuickEntryPage'

export default function LapFormerQuickEntryPage() {
  return <PreparatoryQuickEntryPage kind="lap-former" />
}
